module.exports = __webpack_public_path__ + "static/media/pg.779acb73.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pg.svg
// module id = 957
// module chunks = 0